import React from 'react';
import { Button, Menu, MenuItem, ListItemIcon, ListItemText } from '@mui/material';
import { Language, ExpandMore } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';

const LanguageToggle = () => {
  const { i18n } = useTranslation();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    handleClose();
  };

  const languages = {
    en: { label: 'English', flag: '🇺🇸' },
    es: { label: 'Español', flag: '🇪🇸' },
    ja: { label: '日本語', flag: '🇯🇵' },
    ko: { label: '한국어', flag: '🇰🇷' },
    pt: { label: 'Português', flag: '🇵🇹' }
  };

  const getCurrentLanguage = () => {
    return languages[i18n.language] || languages.en;
  };

  return (
    <>
      <Button
        variant="outlined"
        color="inherit"
        startIcon={<Language />}
        endIcon={<ExpandMore />}
        onClick={handleClick}
        size="small"
        sx={{ color: 'text.primary', borderColor: 'divider', fontWeight: 600 }}
      >
        {getCurrentLanguage().label}
      </Button>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        {Object.entries(languages).map(([code, lang]) => (
          <MenuItem key={code} onClick={() => changeLanguage(code)}>
            <ListItemIcon>{lang.flag}</ListItemIcon>
            <ListItemText>{lang.label}</ListItemText>
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default LanguageToggle;
